module.exports = __webpack_public_path__ + "static/media/carousel_img2.812e4959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img2.png
// module id = 364
// module chunks = 0